import { type } from 'ramda'
import React from 'react'

import { SETTINGS } from '../../_services/services'
import { WIDGET_CONFIGS } from './_configs'
import { useCloseModal } from '../../../../components/modals/ModalsContext'
import { useOpenEditIntegrationTokenModal } from '../../../../utils/routes/modals/modalsActions'
import { useSubdomain } from '../../../../utils/contexts/UrlProvider'
import BigCardPicker from '../../../../packages/kiti/components/form/BigCardPicker'

const WidgetsList = props => {
  const workspace = useSubdomain()
  const closeModal = useCloseModal()
  const openTokenModal = useOpenEditIntegrationTokenModal()

  const handleSelect = ({ id, name, initialState, type, service, onClick }) => {
    const configuration = SETTINGS[service]

    switch (type) {
      case 'TOKEN':
        openTokenModal({ service })
        break

      default:
        onClick(configuration)
        closeModal()
        break
    }
  }

  return <BigCardPicker onChange={handleSelect} options={WIDGET_CONFIGS} />
}

export default WidgetsList
